<div class="page-layout" *transloco="let t">
  <div class="price-list-page">
    <iframe src="https://skolka.online/kalkulacka-licence/" frameborder="0" scrolling="yes" class="price-list-iframe"></iframe>
  </div>
</div>
